module.exports = __webpack_public_path__ + "img/filter_active.28c57dfe.svg";